<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('tenants')" icon="grid">
      <app-default-button
        v-if="$can('create_tenants')"
        @click="isModalActive = true"
        :title="$addLabel('tenant')"
      />
    </app-page-top-section>

    <app-table
      id="app-tenants-table"
      :options="options"
      @action="triggerActions"
    />

    <app-tenant-create-edit-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :selected-url="selectedUrl"
    />

    <app-confirmation-modal
      v-if="confirmationModalActive"
      icon="trash-2"
      modal-id="app-confirmation-modal"
      @confirmed="confirmed('app-tenants-table')"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import DeleteMixin from "../../../../common/Mixin/Global/DeleteMixin";
import { TENANTS_API } from "../../../Config/ApiUrl";

export default {
  name: "TenantList",
  mixins: [HelperMixin, DeleteMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: "",
      delete_url: "",
      options: {
        name: this.$t("tenants"),
        url: TENANTS_API,
        showHeader: true,
        showCount: true,
        columns: [
          {
            title: this.$t("name"),
            type: "text",
            key: "name",
            isVisible: true,
          },
          {
            title: this.$t("short_name"),
            type: "text",
            key: "short_name",
            isVisible: true,
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "is_active",
            isVisible: true,
            modifier: (value) =>
              value
                ? `<span class="badge badge-pill badge-success">${this.$t("active")}</span>`
                : `<span class="badge badge-pill badge-warning">${this.$t("inactive")}</span>`,
          },
          {
            title: this.$t("actions"),
            type: "action",
            key: "id",
            isVisible: true,
          },
        ],
        filters: [],
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-tenant-create-edit-modal",
            modalId: "app-modal",
            url: TENANTS_API,
            name: "edit",
            modifier: () => this.$can("update_tenants"),
          },
          {
            title: this.$t("delete"),
            icon: "trash-2",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "app-confirmation-modal",
            url: TENANTS_API,
            name: "delete",
            modifier: (row) =>
              this.$can("delete_tenants") && parseInt(row.id) !== 1,
          },
        ],
      },
    };
  },
  methods: {
    triggerActions(row, action, active) {
      if (action.name === "edit") {
        this.selectedUrl = `${TENANTS_API}/${row.id}`;
        this.isModalActive = true;
      } else {
        this.getAction(row, action, active);
      }
    },
  },
  watch: {
    isModalActive(val) {
      if (!val) this.selectedUrl = "";
    },
  },
};
</script>
